module.exports = __webpack_public_path__ + "img/FSAB_StylizedFantasyAssassinBlade v3.98a56247.png";